import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    id: 'frontbucket.common.close',
    description: 'Label for triggers that close page components',
    defaultMessage: 'Close',
  },
  cancel: {
    id: 'frontbucket.common.cancel',
    description: 'Label for things that cancel actions',
    defaultMessage: 'Cancel',
  },
  commit: {
    id: 'frontbucket.common.commit',
    description: 'Label for things that need a commit action',
    defaultMessage: 'Commit',
  },
  errorHeading: {
    id: 'frontbucket.common.error',
    description: 'General error message heading',
    defaultMessage: 'Something went wrong',
  },
  expandIcon: {
    id: 'frontbucket.common.expandIcon',
    description:
      'Accessibility label for an icon that indicates an element can be expanded',
    defaultMessage: 'Expand',
  },
  tryAgain: {
    id: 'frontbucket.common.tryAgain',
    description: 'Text to indicate that this will attempt something again',
    defaultMessage: 'Try again',
  },
  createRepositoryButton: {
    id: 'frontbucket.common.createRepositoryButton',
    description: 'Action to create a new repository',
    defaultMessage: 'Create repository',
  },
  save: {
    id: 'frontbucket.common.save',
    description: 'Label for things that save data',
    defaultMessage: 'Save',
  },
  success: {
    id: 'frontbucket.common.success',
    description: 'Text indicating a recently performed action was successful',
    defaultMessage: 'Success',
  },
  clearFilter: {
    id: 'frontbucket.common.clearFilter',
    description: 'Aria-label text for the ClearFilter button',
    defaultMessage: 'Clear filter',
  },
  skip: {
    id: 'frontbucket.common.skip',
    description: 'Skip button label',
    defaultMessage: 'Skip',
  },
  next: {
    id: 'frontbucket.common.next',
    description: 'Next button label',
    defaultMessage: 'Next',
  },
  back: {
    id: 'frontbucket.common.back',
    description: 'Back button label',
    defaultMessage: 'Back',
  },
  gotIt: {
    id: 'frontbucket.common.gotIt',
    description: '"Got it" button label',
    defaultMessage: 'Got it',
  },
});
